// useAdminAmenities — TanStack Query for the county × category matrix
// (ADMIN-02). The page is auto-refreshing (UI-SPEC § 4) so the matrix
// surfaces refresh-status changes without a manual reload — refetchInterval
// 30s while mounted, staleTime 30s so navigating away and back doesn't
// immediately re-fetch.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchAdminAmenities } from '@/lib/api';
import type { AdminAmenitiesDTO } from '@/types/db';

export function useAdminAmenities(): UseQueryResult<AdminAmenitiesDTO, Error> {
  return useQuery<AdminAmenitiesDTO, Error>({
    queryKey: ['admin-amenities'],
    queryFn: ({ signal }) => fetchAdminAmenities(signal),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
